import { defineAsyncComponent } from 'vue'
export default {
  auth: defineAsyncComponent(() => import("/home/runner/work/ott-web-portal2/ott-web-portal2/layouts/auth.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/home/runner/work/ott-web-portal2/ott-web-portal2/layouts/default.vue").then(m => m.default || m)),
  home: defineAsyncComponent(() => import("/home/runner/work/ott-web-portal2/ott-web-portal2/layouts/home.vue").then(m => m.default || m))
}